import api from '@/api'

const { $academic, $student, $pricing, $qSystem } = api;

export const { $ceos } = $academic;
export const { $examsException, $materias, $students } = $student;
export const { $types } = $pricing;
export const { $exams } = $qSystem;
